// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"f2ccc9f8","100":"5eefa493","206":"3ed3fa13","292":"14047f03","453":"5e769716","869":"16821f23","902":"0c3cfbe0","940":"cbd1f4c6"}[chunkId] + ".chunk.js";
};